// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RemoveButton-module__font-s-10___oJ0q6 {
  font-size: 10px !important;
}

.RemoveButton-module__font-s-12___Eqcox {
  font-size: 12px !important;
}

.RemoveButton-module__font-s-13___plmJh {
  font-size: 13px !important;
}

.RemoveButton-module__font-s-14___QvACw {
  font-size: 14px !important;
}

.RemoveButton-module__font-s-15___exY4g {
  font-size: 15px !important;
}

.RemoveButton-module__font-s-16___J6G9m {
  font-size: 16px !important;
}

.RemoveButton-module__font-s-18___CgAlg {
  font-size: 18px !important;
}

.RemoveButton-module__font-s-20___bODo5 {
  font-size: 20px !important;
}

.RemoveButton-module__font-s-22___O3QQt {
  font-size: 22px !important;
}

.RemoveButton-module__font-s-28___JiVUb {
  font-size: 28px !important;
}

.RemoveButton-module__font-w-400___GkGEi {
  font-weight: 400 !important;
}

.RemoveButton-module__font-w-500____Mm73 {
  font-weight: 500 !important;
}

.RemoveButton-module__font-w-600___8TTEQ {
  font-weight: 600 !important;
}

.RemoveButton-module__font-w-700___xlXjs {
  font-weight: 700 !important;
}

.RemoveButton-module__p-5___oErL0 {
  padding: 5px !important;
}

.RemoveButton-module__p-12___MJuP0 {
  padding: 12px !important;
}

.RemoveButton-module__p-16___cuMQN {
  padding: 16px !important;
}

.RemoveButton-module__p-30___Y85XU {
  padding: 30px !important;
}

.RemoveButton-module__p-b-0___BeGYb {
  padding-bottom: 0 !important;
}

.RemoveButton-module__p-b-5___YEgqL {
  padding-bottom: 5px !important;
}

.RemoveButton-module__p-b-10___NHqdp {
  padding-bottom: 10px !important;
}

.RemoveButton-module__p-b-12___vJMs8 {
  padding-bottom: 12px !important;
}

.RemoveButton-module__p-b-16___FB0tl {
  padding-bottom: 16px !important;
}

.RemoveButton-module__p-b-18___HERtB {
  padding-bottom: 18px !important;
}

.RemoveButton-module__p-b-20___SCH5S {
  padding-bottom: 20px !important;
}

.RemoveButton-module__p-b-25___JVrj5 {
  padding-bottom: 25px !important;
}

.RemoveButton-module__p-b-30___RyuT7 {
  padding-bottom: 30px !important;
}

.RemoveButton-module__p-b-50___Br7s4 {
  padding-bottom: 50px !important;
}

.RemoveButton-module__p-t-0___fL_pp {
  padding-top: 0 !important;
}

.RemoveButton-module__p-t-12___YnPmo {
  padding-top: 12px !important;
}

.RemoveButton-module__p-t-16___AyvCg {
  padding-top: 16px !important;
}

.RemoveButton-module__p-t-18___omRud {
  padding-top: 18px !important;
}

.RemoveButton-module__p-t-20___EW2UB {
  padding-top: 20px !important;
}

.RemoveButton-module__p-t-30___H42ph {
  padding-top: 30px !important;
}

.RemoveButton-module__p-t-40___P_i90 {
  padding-top: 40px !important;
}

.RemoveButton-module__p-t-50___eSzaI {
  padding-top: 50px !important;
}

.RemoveButton-module__p-l-20____P_cQ {
  padding-left: 20px !important;
}

.RemoveButton-module__p-l-30____PdrU {
  padding-left: 30px !important;
}

.RemoveButton-module__p-l-40___VQcom {
  padding-left: 40px !important;
}

.RemoveButton-module__p-r-16___ZXD_F {
  padding-right: 16px !important;
}

.RemoveButton-module__p-r-20___WIkZp {
  padding-right: 20px !important;
}

.RemoveButton-module__p-r-30___ySUNh {
  padding-right: 30px !important;
}

.RemoveButton-module__p-r-50___c0Agh {
  padding-right: 50px !important;
}

.RemoveButton-module__p-r-60___VNYyD {
  padding-right: 60px !important;
}

.RemoveButton-module__m-b-1___s9Xsl {
  margin-bottom: 1px !important;
}

.RemoveButton-module__m-b-2___cM9cF {
  margin-bottom: 2px !important;
}

.RemoveButton-module__m-b-6___M4mZ7 {
  margin-bottom: 6px !important;
}

.RemoveButton-module__m-b-8___DWOfy {
  margin-bottom: 8px !important;
}

.RemoveButton-module__m-b-10___sUbSW {
  margin-bottom: 10px !important;
}

.RemoveButton-module__m-b-14___wEUsO {
  margin-bottom: 14px !important;
}

.RemoveButton-module__m-b-16___VmYKZ {
  margin-bottom: 16px !important;
}

.RemoveButton-module__m-b-20___JfTIn {
  margin-bottom: 20px !important;
}

.RemoveButton-module__m-b-22___IODcG {
  margin-bottom: 22px !important;
}

.RemoveButton-module__m-b-24___tLhjE {
  margin-bottom: 24px !important;
}

.RemoveButton-module__m-b-30___y203c {
  margin-bottom: 30px !important;
}

.RemoveButton-module__m-b-32___ato2g {
  margin-bottom: 32px !important;
}

.RemoveButton-module__m-b-40___WVyFq {
  margin-bottom: 40px !important;
}

.RemoveButton-module__m-t-2___ipqYg {
  margin-top: 2px !important;
}

.RemoveButton-module__m-t-3___u_KV0 {
  margin-top: 3px !important;
}

.RemoveButton-module__m-t-4___tof8h {
  margin-top: 4px !important;
}

.RemoveButton-module__m-t-5___X42kY {
  margin-top: 5px !important;
}

.RemoveButton-module__m-t-8___yjvcf {
  margin-top: 8px !important;
}

.RemoveButton-module__m-t-10___AND6j {
  margin-top: 10px !important;
}

.RemoveButton-module__m-t-15___FAYFe {
  margin-top: 15px !important;
}

.RemoveButton-module__m-t-16___SefuI {
  margin-top: 16px !important;
}

.RemoveButton-module__m-t-20___k1Num {
  margin-top: 20px !important;
}

.RemoveButton-module__m-t-22___VZth_ {
  margin-top: 22px !important;
}

.RemoveButton-module__m-t-30___p0j8I {
  margin-top: 30px !important;
}

.RemoveButton-module__m-t-32___yrB8n {
  margin-top: 32px !important;
}

.RemoveButton-module__m-l-auto___OXiNU {
  margin-left: auto !important;
}

.RemoveButton-module__m-l-4___IFeNA {
  margin-left: 4px !important;
}

.RemoveButton-module__m-l-5___JXWKc {
  margin-left: 5px !important;
}

.RemoveButton-module__m-l-6___kU6VQ {
  margin-left: 6px !important;
}

.RemoveButton-module__m-l-8___ba02T {
  margin-left: 8px !important;
}

.RemoveButton-module__m-l-10___kDOUP {
  margin-left: 10px !important;
}

.RemoveButton-module__m-l-16___KMCPv {
  margin-left: 16px !important;
}

.RemoveButton-module__m-l-20___HFoWa {
  margin-left: 20px !important;
}

.RemoveButton-module__m-l-24___W40Vr {
  margin-left: 24px !important;
}

.RemoveButton-module__m-l-30___pJiCJ {
  margin-left: 30px !important;
}

.RemoveButton-module__m-l-35___iajLk {
  margin-left: 35px !important;
}

.RemoveButton-module__m-l-40___LdFP7 {
  margin-left: 40px !important;
}

.RemoveButton-module__m-r-8___Ws5eG {
  margin-right: 8px !important;
}

.RemoveButton-module__m-r-10___GlZ4l {
  margin-right: 10px !important;
}

.RemoveButton-module__m-r-16___towH6 {
  margin-right: 16px !important;
}

.RemoveButton-module__m-r-20___kgb4g {
  margin-right: 20px !important;
}

.RemoveButton-module__m-r-24___scZOj {
  margin-right: 24px !important;
}

.RemoveButton-module__m-r-30___t09cY {
  margin-right: 30px !important;
}

.RemoveButton-module__m-r-40___e5By1 {
  margin-right: 40px !important;
}

.RemoveButton-module__border-r-3___CyEsg {
  border-radius: 3px !important;
}

.RemoveButton-module__border-r-4___hvXIt {
  border-radius: 4px !important;
}

.RemoveButton-module__border-r-6___TFPtK {
  border-radius: 6px !important;
}

.RemoveButton-module__border-r-10___cjrpg {
  border-radius: 10px !important;
}

.RemoveButton-module__border-r-12___inqKW {
  border-radius: 12px !important;
}

.RemoveButton-module__border-r-16___eKZSU {
  border-radius: 16px !important;
}

.RemoveButton-module__border-r-50___tFZWY {
  border-radius: 50% !important;
}

.RemoveButton-module__primary-border___E443r {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.RemoveButton-module__primary-border-b___lCbXN {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.RemoveButton-module__primary-border-t___fbtcj {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.RemoveButton-module__primary-border-l___e38ON {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.RemoveButton-module__primary-border-r___GaTYs {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.RemoveButton-module__secondary-border___YS6DI {
  border: 1px solid #637768;
}

.RemoveButton-module__secondary-border-b___fglsW {
  border-bottom: 1px solid #637768;
}

.RemoveButton-module__secondary-border-t___AGM7n {
  border-top: 1px solid #637768;
}

.RemoveButton-module__secondary-border-l___i09dJ {
  border-left: 1px solid #637768;
}

.RemoveButton-module__secondary-border-r___xgQ93 {
  border-right: 1px solid #637768;
}

.RemoveButton-module__gap-0___P2sYk {
  gap: 0 !important;
}

.RemoveButton-module__gap-2___ID4Ud {
  gap: 2px !important;
}

.RemoveButton-module__gap-4___oTR55 {
  gap: 4px !important;
}

.RemoveButton-module__gap-5___H4wFy {
  gap: 5px !important;
}

.RemoveButton-module__gap-6___Sa5it {
  gap: 6px !important;
}

.RemoveButton-module__gap-8___wTtxY {
  gap: 8px !important;
}

.RemoveButton-module__gap-10___hua6d {
  gap: 10px !important;
}

.RemoveButton-module__gap-12___jzqey {
  gap: 12px !important;
}

.RemoveButton-module__gap-14___vz4LG {
  gap: 14px !important;
}

.RemoveButton-module__gap-16___SyJma {
  gap: 16px !important;
}

.RemoveButton-module__gap-18___FFYxF {
  gap: 18px !important;
}

.RemoveButton-module__gap-20___yQS5Z {
  gap: 20px !important;
}

.RemoveButton-module__gap-24___EBgBi {
  gap: 24px !important;
}

.RemoveButton-module__gap-26___WYc0I {
  gap: 26px !important;
}

.RemoveButton-module__gap-30___zXXr_ {
  gap: 30px !important;
}

.RemoveButton-module__gap-32___r6UGK {
  gap: 32px !important;
}

.RemoveButton-module__gap-40___AmBj3 {
  gap: 40px !important;
}

.RemoveButton-module__gap-50___krD93 {
  gap: 50px !important;
}

.RemoveButton-module__flex-1___npZhN {
  flex: 1;
}

.RemoveButton-module__flex-none___u6Zr8 {
  flex: none !important;
}

.RemoveButton-module__flex-column___xTKR2 {
  display: flex;
  flex-direction: column !important;
}

.RemoveButton-module__flex-row___wLa3I {
  display: flex;
  flex-direction: row !important;
}

.RemoveButton-module__vertically-centered___chg8K {
  display: flex;
  align-items: center !important;
}

.RemoveButton-module__horizontally-centered___F4fB7 {
  display: flex;
  justify-content: center !important;
}

.RemoveButton-module__horizontally-end___EwpLM {
  display: flex;
  justify-content: end !important;
}

.RemoveButton-module__vertically-start___hDdMg {
  display: flex;
  align-items: start !important;
}

.RemoveButton-module__space-between___Z31cL {
  display: flex;
  justify-content: space-between !important;
}

.RemoveButton-module__flex-wrap___CqKca {
  flex-wrap: wrap !important;
}

.RemoveButton-module__height-100___dvokT {
  height: 100%;
}

.RemoveButton-module__width-50___Ar60H {
  width: 50% !important;
}

.RemoveButton-module__width-100___bZxBo {
  width: 100%;
}

.RemoveButton-module__cursor-pointer___ZiS5J {
  cursor: pointer;
}

.RemoveButton-module__cursor-not-allowed___bQiCd {
  cursor: not-allowed !important;
}

.RemoveButton-module__absolute-centered___RybR0 {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.RemoveButton-module__absolute___TjApb {
  position: absolute;
}

.RemoveButton-module__relative___YO1C1 {
  position: relative;
}

.RemoveButton-module__fixed___EPZ4Y {
  position: fixed;
}

.RemoveButton-module__visible___aL7Hw {
  opacity: 1;
}

.RemoveButton-module__invisible___TYDG9 {
  opacity: 0;
}

.RemoveButton-module__col-90___VI5ex {
  width: 90% !important;
}

.RemoveButton-module__col-auto___rSPLZ {
  width: auto !important;
}

.RemoveButton-module__medical-tabs___kWNag {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.RemoveButton-module__medical-table-new___xpQXp {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.RemoveButton-module__medical-table-new___xpQXp:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.RemoveButton-module__medical-table-new___xpQXp::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.RemoveButton-module__medical-table-new___xpQXp::-webkit-scrollbar-track {
  display: none;
}
.RemoveButton-module__medical-table-new___xpQXp.RemoveButton-module__no-pagination___fgX6o {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.RemoveButton-module__medical-table-new___xpQXp.RemoveButton-module__no-pagination___fgX6o:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.RemoveButton-module__medical-table-new___xpQXp.RemoveButton-module__no-pagination___fgX6o::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.RemoveButton-module__medical-table-new___xpQXp.RemoveButton-module__no-pagination___fgX6o::-webkit-scrollbar-track {
  display: none;
}

.RemoveButton-module__medical-table-empty___woYx_ {
  padding: 14px 40px !important;
}

.RemoveButton-module__icon-btn___oXnel {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.RemoveButton-module__search-icon___sN8xq {
  width: 24px;
  height: 24px;
  align-self: center;
}

.RemoveButton-module__disable-select___AJzZ2 {
  user-select: none;
}

.RemoveButton-module__break-word___VGaH3 {
  word-break: break-word;
}

.RemoveButton-module__popup-clear-btn___XxbTg {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.RemoveButton-module__scroll-m-b-20___Ge6jw {
  scroll-margin-bottom: 20px;
}

.RemoveButton-module__button___ZAlBu {
  font-family: var(--font-family);
  font-weight: 500;
  color: #f86363;
  text-transform: uppercase;
  text-align: start;
  align-self: center;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/components/buttons/RemoveButton/RemoveButton.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_fonts.scss","webpack://./../common/src/styles/global/_weights.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EEwBE,+BApBO;EAqBP,gBCxBO;EHCP,cAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;AA+pBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.button {\n  @include get-font($roboto, $medium);\n  color: get-color(red);\n  text-transform: uppercase;\n  text-align: start;\n  align-self: center;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","@use 'sass:map';\n@use 'sass:meta';\n@use 'sizes';\n\n// font families\n// TODO: rename this variable\n$roboto: var(--font-family);\n\n// functions\n@function get-font-size($font-size: null) {\n  // check font size exists\n  @if (map.has-key(sizes.$font-sizes, $font-size)) {\n    $value: map.get(sizes.$font-sizes, $font-size);\n    @if meta.type-of($value) == number {\n      // return font size\n      @return $value;\n    }\n\n    @return null;\n  }\n\n  @return null;\n}\n\n// mixins\n@mixin get-font($font-family: $roboto, $font-weight: 400, $font-size: null) {\n  font-family: $font-family;\n  font-weight: $font-weight;\n  font-size: get-font-size($font-size);\n}\n","$extra-light: 200;\n$light: 300;\n$regular: 400;\n$medium: 500;\n$semi-bold: 600;\n$bold: 700;\n$heavy: 900;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `RemoveButton-module__font-s-10___oJ0q6`,
	"fontS12": `RemoveButton-module__font-s-12___Eqcox`,
	"fontS13": `RemoveButton-module__font-s-13___plmJh`,
	"fontS14": `RemoveButton-module__font-s-14___QvACw`,
	"fontS15": `RemoveButton-module__font-s-15___exY4g`,
	"fontS16": `RemoveButton-module__font-s-16___J6G9m`,
	"fontS18": `RemoveButton-module__font-s-18___CgAlg`,
	"fontS20": `RemoveButton-module__font-s-20___bODo5`,
	"fontS22": `RemoveButton-module__font-s-22___O3QQt`,
	"fontS28": `RemoveButton-module__font-s-28___JiVUb`,
	"fontW400": `RemoveButton-module__font-w-400___GkGEi`,
	"fontW500": `RemoveButton-module__font-w-500____Mm73`,
	"fontW600": `RemoveButton-module__font-w-600___8TTEQ`,
	"fontW700": `RemoveButton-module__font-w-700___xlXjs`,
	"p5": `RemoveButton-module__p-5___oErL0`,
	"p12": `RemoveButton-module__p-12___MJuP0`,
	"p16": `RemoveButton-module__p-16___cuMQN`,
	"p30": `RemoveButton-module__p-30___Y85XU`,
	"pB0": `RemoveButton-module__p-b-0___BeGYb`,
	"pB5": `RemoveButton-module__p-b-5___YEgqL`,
	"pB10": `RemoveButton-module__p-b-10___NHqdp`,
	"pB12": `RemoveButton-module__p-b-12___vJMs8`,
	"pB16": `RemoveButton-module__p-b-16___FB0tl`,
	"pB18": `RemoveButton-module__p-b-18___HERtB`,
	"pB20": `RemoveButton-module__p-b-20___SCH5S`,
	"pB25": `RemoveButton-module__p-b-25___JVrj5`,
	"pB30": `RemoveButton-module__p-b-30___RyuT7`,
	"pB50": `RemoveButton-module__p-b-50___Br7s4`,
	"pT0": `RemoveButton-module__p-t-0___fL_pp`,
	"pT12": `RemoveButton-module__p-t-12___YnPmo`,
	"pT16": `RemoveButton-module__p-t-16___AyvCg`,
	"pT18": `RemoveButton-module__p-t-18___omRud`,
	"pT20": `RemoveButton-module__p-t-20___EW2UB`,
	"pT30": `RemoveButton-module__p-t-30___H42ph`,
	"pT40": `RemoveButton-module__p-t-40___P_i90`,
	"pT50": `RemoveButton-module__p-t-50___eSzaI`,
	"pL20": `RemoveButton-module__p-l-20____P_cQ`,
	"pL30": `RemoveButton-module__p-l-30____PdrU`,
	"pL40": `RemoveButton-module__p-l-40___VQcom`,
	"pR16": `RemoveButton-module__p-r-16___ZXD_F`,
	"pR20": `RemoveButton-module__p-r-20___WIkZp`,
	"pR30": `RemoveButton-module__p-r-30___ySUNh`,
	"pR50": `RemoveButton-module__p-r-50___c0Agh`,
	"pR60": `RemoveButton-module__p-r-60___VNYyD`,
	"mB1": `RemoveButton-module__m-b-1___s9Xsl`,
	"mB2": `RemoveButton-module__m-b-2___cM9cF`,
	"mB6": `RemoveButton-module__m-b-6___M4mZ7`,
	"mB8": `RemoveButton-module__m-b-8___DWOfy`,
	"mB10": `RemoveButton-module__m-b-10___sUbSW`,
	"mB14": `RemoveButton-module__m-b-14___wEUsO`,
	"mB16": `RemoveButton-module__m-b-16___VmYKZ`,
	"mB20": `RemoveButton-module__m-b-20___JfTIn`,
	"mB22": `RemoveButton-module__m-b-22___IODcG`,
	"mB24": `RemoveButton-module__m-b-24___tLhjE`,
	"mB30": `RemoveButton-module__m-b-30___y203c`,
	"mB32": `RemoveButton-module__m-b-32___ato2g`,
	"mB40": `RemoveButton-module__m-b-40___WVyFq`,
	"mT2": `RemoveButton-module__m-t-2___ipqYg`,
	"mT3": `RemoveButton-module__m-t-3___u_KV0`,
	"mT4": `RemoveButton-module__m-t-4___tof8h`,
	"mT5": `RemoveButton-module__m-t-5___X42kY`,
	"mT8": `RemoveButton-module__m-t-8___yjvcf`,
	"mT10": `RemoveButton-module__m-t-10___AND6j`,
	"mT15": `RemoveButton-module__m-t-15___FAYFe`,
	"mT16": `RemoveButton-module__m-t-16___SefuI`,
	"mT20": `RemoveButton-module__m-t-20___k1Num`,
	"mT22": `RemoveButton-module__m-t-22___VZth_`,
	"mT30": `RemoveButton-module__m-t-30___p0j8I`,
	"mT32": `RemoveButton-module__m-t-32___yrB8n`,
	"mLAuto": `RemoveButton-module__m-l-auto___OXiNU`,
	"mL4": `RemoveButton-module__m-l-4___IFeNA`,
	"mL5": `RemoveButton-module__m-l-5___JXWKc`,
	"mL6": `RemoveButton-module__m-l-6___kU6VQ`,
	"mL8": `RemoveButton-module__m-l-8___ba02T`,
	"mL10": `RemoveButton-module__m-l-10___kDOUP`,
	"mL16": `RemoveButton-module__m-l-16___KMCPv`,
	"mL20": `RemoveButton-module__m-l-20___HFoWa`,
	"mL24": `RemoveButton-module__m-l-24___W40Vr`,
	"mL30": `RemoveButton-module__m-l-30___pJiCJ`,
	"mL35": `RemoveButton-module__m-l-35___iajLk`,
	"mL40": `RemoveButton-module__m-l-40___LdFP7`,
	"mR8": `RemoveButton-module__m-r-8___Ws5eG`,
	"mR10": `RemoveButton-module__m-r-10___GlZ4l`,
	"mR16": `RemoveButton-module__m-r-16___towH6`,
	"mR20": `RemoveButton-module__m-r-20___kgb4g`,
	"mR24": `RemoveButton-module__m-r-24___scZOj`,
	"mR30": `RemoveButton-module__m-r-30___t09cY`,
	"mR40": `RemoveButton-module__m-r-40___e5By1`,
	"borderR3": `RemoveButton-module__border-r-3___CyEsg`,
	"borderR4": `RemoveButton-module__border-r-4___hvXIt`,
	"borderR6": `RemoveButton-module__border-r-6___TFPtK`,
	"borderR10": `RemoveButton-module__border-r-10___cjrpg`,
	"borderR12": `RemoveButton-module__border-r-12___inqKW`,
	"borderR16": `RemoveButton-module__border-r-16___eKZSU`,
	"borderR50": `RemoveButton-module__border-r-50___tFZWY`,
	"primaryBorder": `RemoveButton-module__primary-border___E443r`,
	"primaryBorderB": `RemoveButton-module__primary-border-b___lCbXN`,
	"primaryBorderT": `RemoveButton-module__primary-border-t___fbtcj`,
	"primaryBorderL": `RemoveButton-module__primary-border-l___e38ON`,
	"primaryBorderR": `RemoveButton-module__primary-border-r___GaTYs`,
	"secondaryBorder": `RemoveButton-module__secondary-border___YS6DI`,
	"secondaryBorderB": `RemoveButton-module__secondary-border-b___fglsW`,
	"secondaryBorderT": `RemoveButton-module__secondary-border-t___AGM7n`,
	"secondaryBorderL": `RemoveButton-module__secondary-border-l___i09dJ`,
	"secondaryBorderR": `RemoveButton-module__secondary-border-r___xgQ93`,
	"gap0": `RemoveButton-module__gap-0___P2sYk`,
	"gap2": `RemoveButton-module__gap-2___ID4Ud`,
	"gap4": `RemoveButton-module__gap-4___oTR55`,
	"gap5": `RemoveButton-module__gap-5___H4wFy`,
	"gap6": `RemoveButton-module__gap-6___Sa5it`,
	"gap8": `RemoveButton-module__gap-8___wTtxY`,
	"gap10": `RemoveButton-module__gap-10___hua6d`,
	"gap12": `RemoveButton-module__gap-12___jzqey`,
	"gap14": `RemoveButton-module__gap-14___vz4LG`,
	"gap16": `RemoveButton-module__gap-16___SyJma`,
	"gap18": `RemoveButton-module__gap-18___FFYxF`,
	"gap20": `RemoveButton-module__gap-20___yQS5Z`,
	"gap24": `RemoveButton-module__gap-24___EBgBi`,
	"gap26": `RemoveButton-module__gap-26___WYc0I`,
	"gap30": `RemoveButton-module__gap-30___zXXr_`,
	"gap32": `RemoveButton-module__gap-32___r6UGK`,
	"gap40": `RemoveButton-module__gap-40___AmBj3`,
	"gap50": `RemoveButton-module__gap-50___krD93`,
	"flex1": `RemoveButton-module__flex-1___npZhN`,
	"flexNone": `RemoveButton-module__flex-none___u6Zr8`,
	"flexColumn": `RemoveButton-module__flex-column___xTKR2`,
	"flexRow": `RemoveButton-module__flex-row___wLa3I`,
	"verticallyCentered": `RemoveButton-module__vertically-centered___chg8K`,
	"horizontallyCentered": `RemoveButton-module__horizontally-centered___F4fB7`,
	"horizontallyEnd": `RemoveButton-module__horizontally-end___EwpLM`,
	"verticallyStart": `RemoveButton-module__vertically-start___hDdMg`,
	"spaceBetween": `RemoveButton-module__space-between___Z31cL`,
	"flexWrap": `RemoveButton-module__flex-wrap___CqKca`,
	"height100": `RemoveButton-module__height-100___dvokT`,
	"width50": `RemoveButton-module__width-50___Ar60H`,
	"width100": `RemoveButton-module__width-100___bZxBo`,
	"cursorPointer": `RemoveButton-module__cursor-pointer___ZiS5J`,
	"cursorNotAllowed": `RemoveButton-module__cursor-not-allowed___bQiCd`,
	"absoluteCentered": `RemoveButton-module__absolute-centered___RybR0`,
	"absolute": `RemoveButton-module__absolute___TjApb`,
	"relative": `RemoveButton-module__relative___YO1C1`,
	"fixed": `RemoveButton-module__fixed___EPZ4Y`,
	"visible": `RemoveButton-module__visible___aL7Hw`,
	"invisible": `RemoveButton-module__invisible___TYDG9`,
	"col90": `RemoveButton-module__col-90___VI5ex`,
	"colAuto": `RemoveButton-module__col-auto___rSPLZ`,
	"medicalTabs": `RemoveButton-module__medical-tabs___kWNag`,
	"medicalTableNew": `RemoveButton-module__medical-table-new___xpQXp`,
	"noPagination": `RemoveButton-module__no-pagination___fgX6o`,
	"medicalTableEmpty": `RemoveButton-module__medical-table-empty___woYx_`,
	"iconBtn": `RemoveButton-module__icon-btn___oXnel`,
	"searchIcon": `RemoveButton-module__search-icon___sN8xq`,
	"disableSelect": `RemoveButton-module__disable-select___AJzZ2`,
	"breakWord": `RemoveButton-module__break-word___VGaH3`,
	"popupClearBtn": `RemoveButton-module__popup-clear-btn___XxbTg`,
	"scrollMB20": `RemoveButton-module__scroll-m-b-20___Ge6jw`,
	"button": `RemoveButton-module__button___ZAlBu`
};
module.exports = ___CSS_LOADER_EXPORT___;
